export default __webpack_public_path__ + "static/media/review_back_button.aeed2708.png";